import { createStore } from 'redux';
import reducer from './reducer';
import middlewares, { sagaMiddleware } from './middlewares';
import sagas from './sagas';

export default createStore(reducer, middlewares);

sagaMiddleware.run(sagas);
